export const PAGE_SIZE_OPTIONS = ['5', '10', '25', '50'];

// Upper bound when hydrating already-selected records by id (e.g. resolving filter labels for a
// saved view). The page size is otherwise derived from the selection count, which can grow past a
// server-enforced maximum; cap it so the request stays within limits instead of erroring out.
export const MAX_IDS_HYDRATION_PAGE_SIZE = 100;
